import * as userApi from '@/api/companyUserApi.js'
import { useUserStore } from '@/stores/userStore'

export default {
    namespaced: true,
    state() {
        return {
            companyListUser: [],
        }
    },
    getters: {
        getListUsers(state) {
            return state.companyListUser
        },
    },
    mutations: {
        setListUsers(state, listData) {
            state.companyListUser = JSON.parse(listData)
        },
    },
    actions: {

        async users({ commit }, id) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await userApi.listUsers(token, id)

            if (dataResp) {
                commit('setListUsers', JSON.stringify(dataResp))
            }
        },

        async updateUser({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await userApi.updateUser(token, data)
        },

        async deletUser({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await userApi.deletUser(token, data)
        }
    }
}